import React from 'react';

function Text({ className = '', asterisk, colon, style = {}, highLight, children }) {
    return (
        <div className={`bs-text ${className}`}>
            {!!asterisk && <span style={{color: 'red', ...style}}>*</span>}
            <span style={{color: highLight}}>{children}</span>
            {colon && ':'}
        </div>
    );
}

export default Text;


// WEBPACK FOOTER //
// ./src/components/basicElement/Text.js